// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".catalogs-container[data-v-363f07aa]{max-width:1240px;margin:0 auto}.catalogs-image[data-v-363f07aa]{width:265px;height:376px;margin-bottom:20px;box-shadow:4px 4px 6px rgba(0,0,0,.15)}.catalog-text[data-v-363f07aa]{margin:0 auto;max-width:265px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
